/**
 * Firestore write batches are limited to 500 operations. Use this helper when
 * deleting many documents from the client (e.g. merged auto-tracked segments).
 */

import { db } from './firebase';
import { writeBatch, doc } from 'firebase/firestore';

export const FIRESTORE_BATCH_LIMIT = 500;

export async function deleteFirestoreDocsInBatches(
  collectionName: string,
  ids: string[],
  onProgress?: (deleted: number, total: number) => void,
): Promise<void> {
  const unique = Array.from(
    new Set(
      ids
        .map(id => (typeof id === 'string' ? id.trim() : ''))
        .filter(Boolean),
    ),
  );
  if (unique.length === 0) return;

  const total = unique.length;
  let deleted = 0;

  for (let i = 0; i < unique.length; i += FIRESTORE_BATCH_LIMIT) {
    const chunk = unique.slice(i, i + FIRESTORE_BATCH_LIMIT);
    const batch = writeBatch(db);
    for (const id of chunk) {
      batch.delete(doc(db, collectionName, id));
    }
    await batch.commit();
    deleted += chunk.length;
    onProgress?.(deleted, total);
  }
}
